module.exports = __webpack_public_path__ + "media/images/ui__textCross-ce4a96aa96dd6d3c7fc9596d21ae16ff.png";